import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const MoreActive = () => (_jsxs("svg", Object.assign({ viewBox: "0 0 256 256", xmlns: "http://www.w3.org/2000/svg" }, { children: [_jsx("circle", { cx: "128", cy: "128", r: "128" }), _jsxs("g", Object.assign({ fill: "#fff" }, { children: [_jsx("path", { d: "m169.91 108.14h28.67v28.67h-28.67z" }), _jsx("path", { d: "m114.81 108.14h28.67v28.67h-28.67z" }), _jsx("path", { d: "m59.71 108.14h28.67v28.67h-28.67z" })] }))] })));
MoreActive.iconName = "moreactive";
MoreActive.iconCategory = "Misc - Deprecated";
MoreActive.deprecated = true;
export default MoreActive;
